import { provideRouter, withComponentInputBinding } from '@angular/router';
import { ApplicationConfig, inject, isDevMode, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideTransloco, provideTranslocoLoader } from '@jsverse/transloco';
import { I18nLoader } from './shared/service/i18n-loader';
import { AuthService } from './shared/service/auth.service';

import { provideKeycloakAngular } from './keycloak.config';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    // Eagerly create AuthService so it reacts to session expiry on every page
    provideAppInitializer(() => { inject(AuthService); }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor])),
    provideAnimationsAsync(),
    provideTransloco({
      config: {
        availableLangs: ['en', 'it', 'de', 'es'],
        defaultLang: localStorage.getItem('lang') ?? 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
    }),
    provideTranslocoLoader(I18nLoader),
  ]
};
